<template>
  <div class="py-4">
    <b-container>
      <TableReports @reports:assignTags="(payload) => onAssignTags(payload)" />

      <ModalReportName />
      <ModalReportAccess />

      <TagsModal
        v-if="$user.get().is_superuser"
        @update:show="(value) => (showTagsModal = value)"
        :id="selectedReportIDs"
        :show="showTagsModal"
      />
    </b-container>
  </div>
</template>

<script>
import Vue from 'vue'
import {
  defineComponent,
  ref,
  watch,
  onMounted,
  onUnmounted
} from '@vue/composition-api'

import TableReports from '@components/TableReports'
import ModalReportName from '@components/ModalReportName'
import ModalReportAccess from '@components/ModalReportAccess'

import TagsModal from '@components/TagsModal'

export default defineComponent({
  name: 'Reports',
  title: 'Reports',
  components: {
    TableReports,
    ModalReportName,
    ModalReportAccess,
    TagsModal
  },
  setup() {
    const showTagsModal = ref(false)
    const selectedReportIDs = ref([])

    const onAssignTags = (rows) => {
      selectedReportIDs.value = rows

      showTagsModal.value = true
    }

    watch(
      () => showTagsModal.value,
      (newShowTagsModal) => {
        if (newShowTagsModal) return

        Vue.prototype.$bus.$emit('datatable-unselect-rows')
      }
    )

    onMounted(() => {
      Vue.prototype.$bus.trackEvent('toggle-modal', async (payload) => {
        if ('report-tags' === payload.key) {
          selectedReportIDs.value = [payload.id]

          showTagsModal.value = payload.active
        }
      })
    })

    onUnmounted(() => {
      Vue.prototype.$bus.destroyEvents()
    })

    return {
      showTagsModal,
      selectedReportIDs,
      onAssignTags
    }
  }
})
</script>
